<template>
  <KaeruWidget
    project="jigsaw"
    board="bug-reports"
    app-mount-path="/feedback/bug-reports"
  />
</template>

<script setup lang="ts">
import KaeruWidget from '../components/KaeruWidget.vue'
</script>
